import React from 'react';

const Home = () => {
  return (
    <div>
      <h1>Bienvenido a la Cuponera de Descuentos</h1>
    </div>
  );
};

export default Home;